import {Component} from 'react';
import Router from 'next/router';

interface Props {
    to: string;
}

/**
 * Client-side redirect stub used at legacy portal routes after the
 * Phase 3 IA renames. Calls Router.replace on mount and shows a brief
 * "Redirecting…" line in case the JS chunk is slow.
 *
 * Used by:
 *   /portal/billing          → /portal/plan
 *   /portal/plans            → /portal/plan
 *   /portal/billing-history  → /portal/invoices
 *   /portal/billing-topup    → /portal/credits
 *   /portal/billing-usage    → /portal/usage
 *   /portal/conversion-history → /portal/conversions
 *
 * Kept for at least 30 days after Phase 6 flag flip, then deleted.
 */
export default class PortalRedirect extends Component<Props> {
    componentDidMount(): void {
        if (typeof window !== 'undefined') {
            Router.replace(this.props.to);
        }
    }

    render() {
        return (
            <div style={{padding: 32, textAlign: 'center', color: '#697386', fontFamily: 'Inter, system-ui, sans-serif'}}>
                <meta httpEquiv="refresh" content={`0;url=${this.props.to}`} />
                Redirecting to <a href={this.props.to}>{this.props.to}</a>…
            </div>
        );
    }
}
